import BlockIcon from '@mui/icons-material/Block';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { DashboardT } from 'business/definitions';

/**
 * Determines the appropriate icon to display for a dashboard.
 * - If a dashboard was not shared directly with the support, it will still appear but with a block icon.
 * - If the dashboard is editable, it will show an edit icon.
 * - If the dashboard is not editable, it will show a visibility icon.
 */
export const getDashboardIcon = (dashboard: DashboardT): React.ReactNode => {
    if (dashboard.isSupportAccess) {
        return <BlockIcon />;
    }
    if (dashboard.canEdit) {
        return <EditIcon />;
    }
    return <VisibilityIcon />;
};
